import {Injectable, inject} from '@angular/core';
import {AnalyticsService} from '../shared/analytics/analytics.service';
import {recordFavoriteWebEvent} from '../shared/google-analytics';

export type FavoriteEvent = 'favorites_widget_view' | 'favorite_added' | 'favorite_removed' | 'favorite_opened' | 'favorites_widget_hidden';
export type FavoriteEventParameters = {
  entityType?: 'container' | 'item';
  source: 'containers' | 'details' | 'widget' | 'list' | 'reports';
  outcome?: 'succeeded' | 'failed';
};

@Injectable({providedIn: 'root'})
export class FavoritesAnalyticsService {
  private readonly analytics = inject(AnalyticsService);
  record(event: FavoriteEvent, parameters: FavoriteEventParameters): void {
    // Copy only controlled fields; never forward entities, routes, IDs or error text.
    const safe: Record<string, string> = {source: parameters.source};
    if (parameters.entityType) safe['entityType'] = parameters.entityType;
    if (parameters.outcome) safe['outcome'] = parameters.outcome;
    try {
      if (this.analytics.isAndroid) void this.analytics.logFavorite(event, safe);
      else recordFavoriteWebEvent(event, safe);
    } catch {
      // Analytics must not interrupt inventory actions or navigation.
    }
  }
}
